module.exports = __webpack_public_path__ + "static/img/biankuang04.2daaba1.png";


//////////////////
// WEBPACK FOOTER
// ./static/biankuang04.png
// module id = fiab
// module chunks = 1